<template>
  <div class="form-outline">
    <form-legend :field="field" class="pt-1" />
    <v-select
      v-model="fieldValue"
      :clearable="field.field_options.include_blank_option && !readonly"
      :items="field.field_options.options"
      item-text="label"
      :item-value="(item) => `${item.label} ${item.email}`"
      single-line
      :rules="getFieldRules({ field, required: field.required })"
      :hint="field.field_options.description"
      persistent-hint
      :readonly="readonly"
      v-bind="darkOrLightMode"
      color="primary-action"
      item-color="primary-action"
    >
      <template v-slot:message="{ message }">
        <legend v-html="message" />
      </template>
    </v-select>
  </div>
</template>

<script>
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [formsMixin],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  data() {
    return {
      fieldValue: this.formModel[this.field.cid] ? this.formModel[this.field.cid] : '',
    };
  },
  watch: {
    fieldValue(newValue) {
      this.$emit('formUpdated', this.field.cid, newValue);
    },
    formModel(newValue) {
      const value = newValue[this.field.cid] ? newValue[this.field.cid] : '';
      if (this.fieldValue != value) {
        this.fieldValue = value;
      }
    },
  },
};
</script>
